import React, {Component, createRef} from "react";
import styles from './FJMediaCollectionView.module.less';
import FJMediaCollectionItem from "./FJMediaCollectionItem";
import FJCustomScroll from 'fj-components/FJCustomScroll'
import FJLayout from 'fj-components/FJLayout';
import classNames from 'classnames';

class FJMediaCollectionView extends Component {

	constructor(props) {
		super(props);
		this._layout = createRef();
	}

	componentDidMount() {
		this._layout.current.updateUI();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if ((this.props.active && this.props.active !== prevProps.active)
			|| this.props.isOpenLeftMenu !== prevProps.isOpenLeftMenu) {
			setTimeout(() => {
				this._layout.current.updateUI();
			}, 400);
		}
	}

	render() {
		let {
			collections,
			onSearch,
			music,
			hasShadow,
			active,
			isOpenLeftMenu = true,
			itemRatio = 1.76,
		} = this.props;

		const basicWidth = 360;

		return (
			<div
				className={classNames(styles.view_container, {[styles.music]: music}, {[styles.closeLeftMenu]: !isOpenLeftMenu}, {[styles.active]: active})}>
				<div className={styles.list_content}>
					<div className={styles.item_box}>
						<FJCustomScroll>
							<ul className={styles.ul_box}>
								<FJLayout basicWidth={basicWidth}
								          className={styles.layout}
								          ref={this._layout}
								          space={0}
								          active
								          render={(itemWidth) => {
									          let items = [];
									          let previewHeight = itemWidth / itemRatio;
									          let itemHeight = previewHeight + (music ? 0 : 75);
									          collections.map((item, index) => {
										          return items.push(
											          <FJMediaCollectionItem key={index}
											                                 id={item.id}
											                                 keywords={item.keywords}
											                                 name={item.name}
											                                 url={item.cover}
											                                 onSearch={onSearch}
											                                 width={itemWidth}
											                                 height={itemHeight}
											                                 previewHeight={previewHeight}
											                                 hasShadow={hasShadow}
											          />
										          )
									          })
									          return items;
								          }}/>
							</ul>
						</FJCustomScroll>
					</div>
				</div>
			</div>
		)
	}

}


export default FJMediaCollectionView;